import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'; // Ensure moment.js is installed

const ListHeaderTableComponent = ({ headers, rows }) => {
  // Function to check if a value is a valid date
  const isDate = (value) => moment(value, moment.ISO_8601, true).isValid();

  // Function to render the table content
  const renderTableRows = () => {
    const rowsWithHeaders = [];
    
    // Iterate through each header row
    headers.forEach((headerRow, headerIndex) => {
      // Add the header row
      rowsWithHeaders.push(
        <tr key={`header-row-${headerIndex}`}>
          {headerRow.map((header, colIndex) => (
            <th key={`header-${headerIndex}-${colIndex}`} className="tdHeadingText">
              {header}
            </th>
          ))}
        </tr>
      );

      // Iterate through each data row associated with the current header row
      rows.forEach((dataRow, rowIndex) => {
        if (rowIndex === headerIndex) { // Display data row corresponding to the current header row
          rowsWithHeaders.push(
            <tr key={`data-row-${headerIndex}-${rowIndex}`}>
              {dataRow.map((cell, colIndex) => (
                <td key={`cell-${headerIndex}-${rowIndex}-${colIndex}`} className="tdDetailsText">
                  {/* Format date if the cell contains a date string */}
                  {isDate(cell)
                    ? moment(cell).format("DD-MMM-YYYY")
                    : cell}
                </td>
              ))}
            </tr>
          );
        }
      });

      // Add a blank row after the current data row
      rowsWithHeaders.push(
        <tr key={`blank-row-${headerIndex}`} className="blank_row">
          <td colSpan={headerRow.length}></td>
        </tr>
      );
    });

    return rowsWithHeaders;
  };

  return (
    <div className="row">
      <table>
        <thead>
          {/* Header rows are included in the body */}
        </thead>
        <tbody>
          {renderTableRows()}
        </tbody>
      </table>
    </div>
  );
};

// Define PropTypes for type checking
ListHeaderTableComponent.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date)
  ]))).isRequired
};

export default ListHeaderTableComponent;






///////////////USES//////////////////////////////

// import React from 'react';
// import TableComponent from './TableComponent';

// const App = () => {
//   const headers = [
//     ['PO Number', 'PO Date', 'Consignee Name'],
//     ['Item Name', 'PO Qty', 'PO Value']
//   ];

//   const rows = [
//     ['12345', '2024-09-07', 'John Doe'],
//     ['Widget', 100, '$500'],
//   ];

//   return (
//     <div>
//       <TableComponent headers={headers} rows={rows} />
//     </div>
//   );
// };

// export default App;
